import React, { Component, useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import Tap from 'react-interactions'
import axios  from 'axios';
import { ProjectId } from '../../index.js';
import { ProductContext } from '../../context';
import Cookie, {eraseCookie, parseJwt} from './Cookie';
import ProductList from './ProductList.js';





const myProjects = [
  {
    'projectName': 'Xsolla Demo Store',
    'merchant_id': 15924,
    'project_id': 37471,
    'login_id': 'b3632bfa-275e-11e9-9244-42010aa80004',
  },{
    'projectName': 'Xsplit',
    'project_id': 36816,
    'login_id': '19f1d2f2-25c3-11e9-9244-42010aa80004',
  },{
    'projectName': 'Life is Feudal',
    'project_id': 21190,
    'login_id': '740cd4af-2a69-11e9-9244-42010aa80004',
  },{
    'projectName': 'Giiku',
    'merchant_id': 2340,
    'project_id': 57206,
    'login_id': '037cb6c3-8047-11ea-a85b-42010aa80004',
  }
]





export default function XLogin (
  props
  ) {

    const [state, setState] = useState({
      shown: true,
      logToken: null,
      psToken: null,
    });



  const handleZclick = (event) => {
  //  console.log('123');
    setState({ shown: false });
    event.currentTarget.style.display = 'none';
  };




  const logOutHandler = () => {
    eraseCookie("xsolla_login_token", null);
    eraseCookie("xsolla_last_click_id", null);
    window.location.reload();
    // unauthorizedFlow();
  }


  const valueFromContext = React.useContext(ProductContext);

  const setStateFrom = valueFromContext.setStateFrom;
  const setPsToken = valueFromContext.setPsToken;
  const setProjectId = valueFromContext.setProjectId;
  const setMerchantId = valueFromContext.setMerchantId;
  let logToken = valueFromContext.logToken;

  let flow;
  let userToken;
  let user;

  const logInButtonHandler = () => {
    setState({ shown: true })
  }






  const unauthorizedFlow = () => {
  //  console.log('unauthorizedFlow');
    setState({ logToken: null })
    flow = 'unauthorized';
    setState({ shown: true })
  }

  const authorizedFlow = (tkn, projectId) => {
  //  console.log('authorizedFlow', tkn);
    setState({ logToken: tkn, shown: false })
    user = parseJwt(tkn);
  //  console.log('user = ', user);


    flow = 'authorized';
    userToken = tkn;
    valueFromContext.setStateFrom('user', user);
    valueFromContext.setStateFrom('projectId', projectId);
    generatePStoken(userToken, projectId); //TODO: перенести в товары
  }


  //https://confluence.xsolla.com:8443/display/SP/POST+Generate+PayStation+token+by+JWT
  const generatePStoken = (userToken, projectId) => {

    let tokenData = JSON.stringify({
      xsolla_login_user_id: user.sub,
      token_data: {
        user: { 'id': { 'value': user.sub } },
        settings: {
          project_id: projectId,//myProjects[0]['project_id'],// window.xProjectId, //myProjects[0]['project_id'], //36816, //40702,
          currency: 'USD',
          ui: {
            theme: 'dark'
          }
        }
      }
    });
    let opts = {
      url: "https://store.xsolla.com/api/v1/xsolla_login/paystation/token",
      crossdomain: true,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userToken
      },
      data: tokenData
    }

    // console.log('axios options = ', opts);
    axios(opts)
      .then(function (response) {
      //  console.log('L2PS response.data = ', response.data);
      //  console.log('L2PS response.data.token = ', response.data.token);
        let psToken = response.data.token;
          setPsToken(psToken);
          // createCart(psToken);
        }
      )
      .catch(function (error) {
        console.log('L2PS ERROR = ', error.response)
      });
  }





  const addToCart = ({sku = 'gun_1'}) => {

    let opts = {
      url: 'https://store.xsolla.com/api/v1/cart/'+ 666 +'/item/' + sku,
      crossdomain: true,
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + userToken
      },
      data: JSON.stringify({
        quantity: 1
      }),
    }
    axios(opts)
    .then(function (response) {
      //  console.log('L2PS response.data = ', response.data);
      //  console.log('L2PS response.data.token = ', response.data.token);
      let resp = response.data;
      }
    )
    .catch(function (error) {
     console.log('L2PS ERROR = ', error.response)
    });


  }



  const createCart = (psToken) => {
    let opts = {
      url: 'https://store.xsolla.com/api/v1/cart/',
      method: "POST",
      headers: {
        Authorization: "Bearer " + userToken
      }
    }
    axios(opts)
    .then(function (response) {
      // debugger
    //  console.log(response)
    })
    .catch(function (error) {
      // debugger
    //  console.log('L2PS ERROR = ', error.response)
    });
  }

  const eraseCookie = (o) => {
    return (
        document.cookie = o + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;"
    )
  }

  const element_id = 'xl_auth';
  const options = {
      'width': 600,
      'height': 550,
      // route: XL.ROUTES.REGISTRATION //TODO: регистрация по умолчанию?
  };



    const loadLogin = () => {
      let urlParams;
      urlParams = new URLSearchParams(window.location.search);
      console.log('urlParams = ', urlParams.get('project_id'));

      let xMerchantId
      if (urlParams && urlParams.get('merchant_id')) {
        xMerchantId = parseInt(urlParams.get('merchant_id'));
          localStorage.setItem('xsolla_react_store_merchant', xMerchantId);
      } else {
          xMerchantId = localStorage.getItem('xsolla_react_store_merchant') || 2340;
          xMerchantId = parseInt(xProjectId);
      }

      let xProjectId
      if (urlParams && urlParams.get('project_id')) {
          xProjectId = parseInt(urlParams.get('project_id'));
          eraseCookie('xsolla_login_token');
          localStorage.setItem('xsolla_react_store_project', xProjectId);
      } else {
          xProjectId = localStorage.getItem('xsolla_react_store_project') || 37471;
          xProjectId = parseInt(xProjectId);
      }

      let xLoginId;
      if (urlParams && urlParams.get('login_id')) {
          xLoginId = urlParams.get('login_id');
          localStorage.setItem('xsolla_react_store_login', xLoginId);
      } else {
          xLoginId = localStorage.getItem('xsolla_react_store_login') || 'b3632bfa-275e-11e9-9244-42010aa80004'
      }

      let mainURL = 'https://xsolla-react-store.netlify.app/store/';

      console.log('xProjectId = ', xProjectId);
      console.log('xLoginId = ', xLoginId);

      setProjectId(xProjectId);

      window['XL'].init({
          projectId: xLoginId,
          loginUrl: mainURL,
          locale: 'en_US',
          onlyWidgets: true,
          fields: 'email'
      });

      XloginInit();
      let cke = Cookie();
      (cke) ? authorizedFlow(cke, xProjectId) : unauthorizedFlow();


    }

    let login;


    function XloginInit() {
      login = window['XL'].AuthWidget(element_id, options);
    }


    const loadXL = ()=> {
      let s = document.createElement("script");
      let widgetInstance;
      s.type = "text/javascript";
      s.async = true;
      s.src = "//cdn.xsolla.net/xsolla-login-widget/sdk/1.3.2/xl.min.js";
      s.addEventListener(
        "load",
        function(e) {
          loadLogin()
        },
        false
      );
      let head = document.getElementsByTagName("head")[0];
      head.appendChild(s);
    }




  useEffect(() => {
    if (typeof window['Xl']  !== 'function') {
      login = true;
      loadXL()
        // XloginInit();
        // let cke = Cookie();
        // (cke) ? authorizedFlow(cke) : unauthorizedFlow();
      }
    },[])





    return (
      <div style={{flexGrow:1}}>




              <div>



                <CssXpop
                  style={{ display: state.shown ? 'flex' : 'none' }}
                  sb={valueFromContext['sbShown']}
                >


                  <CssXpopB>

                    <CssLoginInfo>Current project: <b>{window.xProjectId}</b></CssLoginInfo>

                    <CssLoginPop>
                      <div id="xl_auth"></div>
                    </CssLoginPop>

                    <CssLoginInfo>
                      {myProjects.map((onePr, i) => {
                        let pr = onePr['project_id'];
                        let login = onePr['login_id'];
                        let url = `https://xsolla-react-store.netlify.app/store/`
                        let urlFull = `${url}?project_id=${pr}&login_id=${login}`;
                        return (
                          <div
                            key={pr + i}
                            style={{ marginBottom: '1em' }}
                          >
                            {/* <div>{onePr.projectName}</div> */}
                            <div style={{ fontSize: '0.4em' }}>
                              <a href={urlFull}>
                                {pr}: {onePr.projectName}
                                {/* {url}<br /> */}
                                {/* ?project_id={pr}<br /> */}
                                {/* &login_id={login} */}
                              </a>
                            </div>
                          </div>
                        )
                      })}
                      <p>Open any Xsolla Store using GET parameters <br />
                        <b>project_id</b> and <b>login_id</b> (login must point back to https://xsolla-react-store.netlify.app/store/)</p>
                    </CssLoginInfo>

                  </CssXpopB>


                  {/* <XpopZ onClick={handleZclick} /> */}
                  <CssXpopZ sb={valueFromContext['sbShown']} />
                </CssXpop>
              </div>



      </div>
    )







}












const CssXpop = styled.div`
  position: fixed;
  /* overflow-y: scroll; */
  top: 0;
  left: ${({sb})=> sb ? '320px' : '0px'};
  right:0;
  bottom:0;
  min-height: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  overflow-y: scroll;
  padding: 40px 0;
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    left: 0 !important;
  }

  @media (max-width: 479px) {
  }
`
const CssXpopB = styled.div`
color: white;
  position: absolute;
  top: 0;
  left: 0;
  right:0;
  min-height: 100%;
  z-index: 100;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
`
const CssXpopZ = styled.div`
  position: fixed;
  z-index: 99;
  background: rgba(0,0,0,0.8);
  top: 0;
  left: ${({sb})=> sb ? '320px' : '0px'};
  bottom:0;
  right:0;
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    left: 0 !important;
  }

  @media (max-width: 479px) {
  }
`

const CssLoginInfo = styled.div`
  padding: 20px 70px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  font-size: 22px;
  /* flex-basis: 50%; */
  width: 600px;
  /* text-align: center; */
  /* padding: 36px; */
  & a {
    /* font-family: 'PS Mono', Courier, monospace; */
    text-decoration: underline;
    font-size: 28px;
    line-height: 0px;
  }
`
const CssLoginPop = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  text-align: center;
  padding: 36px;
  /* background: white; */
  overflow: hidden;
  /* width: 460px; */
  margin: 0 70px;
  border-radius: 8px;
`


